import React, { useEffect, useRef } from "react";
import { Transformer } from "markmap-lib";
import { Markmap } from "markmap-view";

const FONT_SIZE = 20;

const transformer = new Transformer();

export default function MarkmapRenderer({ markdown }: { markdown: string }) {
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (!svgRef.current) return;

    while (svgRef.current.firstChild) {
      svgRef.current.removeChild(svgRef.current.firstChild);
    }

    const { root } = transformer.transform(markdown);
    Markmap.create(svgRef.current, {}, root);
    svgRef.current.querySelectorAll("text").forEach((el) => {
      const textEl = el as SVGTextElement;
      textEl.setAttribute("fill", "#FFFFFF");
      textEl.setAttribute("font-size", FONT_SIZE.toString());
      textEl.setAttribute("font-family", "inherit");
    });
  }, [markdown]);

  return (
    <svg
      ref={svgRef}
      className="w-full"
      style={{
        fontSize: "20px",
        minHeight: "320px",
        overflow: "visible",
      }}
    />
  );
}
